import React from 'react'
import styles from './TimeLine.module.scss'
import { Tabs } from '..'
import { icons } from 'assets'
import ScrollBar from './ScrollBar'
import Thumbnails from './Thumbnails'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { EDITOR_TIMELINE_STORE, TimelineTabs as tabs } from 'store'
import { LabelDetails } from '../Tabs'
import { TimeLineProps } from './types'

const labels: { [key in tabs]: LabelDetails } = {
  [tabs.AI_FRAME_VIEW]: { type: 'text', value: 'x1', title: tabs.AI_FRAME_VIEW },
  [tabs.AUTO_CYCLE_VIEW]: { type: 'icon', value: icons.syncArrows, title: tabs.AUTO_CYCLE_VIEW },
  [tabs.IN_OUT_VIEW]: { type: 'icon', value: icons.crossingArrows, title: tabs.IN_OUT_VIEW }
}

const TimeLine = (props: TimeLineProps) => {
  const {
    [EDITOR_TIMELINE_STORE]: {
      selectedTab,
      setSelectedTab,
      goForwardsToTimeline,
      goBackwardsToTimeline
    }
  } = props

  const handleWheel = ({ deltaY }) => {
    deltaY < 0
      ? goForwardsToTimeline()
      : goBackwardsToTimeline()
  }

  return (
    <div className={styles.container}>
      <Tabs
        vertical
        tabs={Object.values(tabs)}
        labels={labels}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <div
        className={styles.body}
        onWheel={handleWheel}
      >
        <ScrollBar />
        <Thumbnails />
      </div>
    </div>
  )
}

export default inject(EDITOR_TIMELINE_STORE)(observer(TimeLine))
